export { IAMService } from './iam.service';
